export const styles = {
	emailsPaper: {
		flexGrow: 1,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'auto',
		position: 'relative'
	},
	emailsList: {
		flexGrow: 1
	},
	emailsGrid: {
		display: 'flex',
		overflow: 'hidden'
	},
	btnTestEmail: {
		textTransform: 'unset',
		fontSize: '15px',
		marginLeft: '15px',
		marginRight: 'auto',
		'&:disabled svg': {
			fill: 'rgb(0,0,0,0.26)'
		}
	},
	actionButtons: {
		textTransform: 'capitalize'
	},
	saveBtn: {
		marginRight: '8px',
		marginLeft: '8px',
		minWidth: 100,
		color: '#fff'
	},
	iconOffset: {
		marginRight: '8px',
		color: 'white'
	},
	listItem: {
		'&:hover': {
			backgroundColor: '#efefef'
		}
	}
};
